import { render, staticRenderFns } from "./LawTradeFairCenterList.vue?vue&type=template&id=e1ef079a&"
import script from "./LawTradeFairCenterList.vue?vue&type=script&lang=js&"
export * from "./LawTradeFairCenterList.vue?vue&type=script&lang=js&"
import style0 from "./LawTradeFairCenterList.vue?vue&type=style&index=0&id=e1ef079a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports